module.exports = __webpack_public_path__ + "static/media/snowboarding.4c711f5f.svg";